var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalVideoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7211 4.78093H19.3642C20.2705 4.78093 21 5.63413 21 6.66831V20.0868C21 21.1468 20.2705 22 19.3642 22H1.63579C0.729474 22 0 21.1468 0 20.0868V6.69416C0 5.63413 0.729474 4.78093 1.63579 4.78093H7.49368L5.57053 1.52327C5.30526 1.08375 5.39368 0.489094 5.76947 0.17884C6.14526 -0.131413 6.65368 -0.0279956 6.91895 0.41153L9.10737 4.10872L11.2958 0.437385C11.5389 -0.00214112 12.0695 -0.105559 12.4453 0.204695C12.7989 0.514948 12.9095 1.1096 12.6442 1.54913L10.7211 4.78093ZM1.75 19H15.75V7H1.75V19ZM18.375 14C17.8937 14 17.5 13.55 17.5 13C17.5 12.45 17.8937 12 18.375 12C18.8563 12 19.25 12.45 19.25 13C19.2281 13.525 18.8563 14 18.375 14ZM17.0625 17.5C17.0625 18.325 17.6531 19 18.375 19C19.0969 19 19.6547 18.325 19.6875 17.5C19.6875 16.675 19.0969 16 18.375 16C17.6531 16 17.0625 16.675 17.0625 17.5Z",
    fill: "url(#paint0_linear_201:1994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201:1994",
    x1: 31.5,
    y1: 11,
    x2: 9.52378,
    y2: -9.9773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalVideoIcon);
export default __webpack_public_path__ + "static/media/PersonalVideoIcon.dc487b46.svg";
export { ForwardRef as ReactComponent };